// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-avatar{position:relative}.user-avatar img{height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.user-avatar .profile-picture{border:2px solid transparent;max-height:176px;max-width:176px;transition:border-color .3s var(--g-animation-easing)}.user-avatar .avatar-icon{background-color:#fff;border-color:var(--g-profile-border);color:var(--v-accentPurple-base)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
